export enum AgentFormSectionId {
  AutoAssignment = "auto-assignment",
  BrowserNotifications = "browser-notifications",
  EmailNotifications = "email-notifications",
  TwoFactorAuthentication = "two-factor-authentication",
  PasswordManagement = "password-management",
  DeleteAgent = "delete-agent",
  PermissionsManagement = "permissions-management",
  TeamsManagement = "teams-management",
  Signature = "signature",
}
